import { createContext, useContext } from 'react'
export type MarketingAccess = {
  account: string
  available: boolean
  ready: boolean
  isCurrent: () => boolean
  open: () => void
}
export const MarketingAccessContext = createContext<{
  access: MarketingAccess | null
  setAccess: (value: MarketingAccess | null) => void
}>({ access: null, setAccess: () => {} })
export const useMarketingAccess = () => useContext(MarketingAccessContext)
